import './index.css';

import { ComparisonTableMobile } from './comparison-table-mobile';
import { comparisonTable } from '@/constants/comparison-table';
import { ComparisonTableDesktop } from './comparison-table-desktop';
import { useResponsive } from '@/hooks/use-responsive';

const ComparisonTable = () => {
  const { isMobileOrTablet } = useResponsive();
  return (
    <div className="my-10 lg:my-20 container">
      <h2 className="text-xl text-center mb-4 lg:mb-16 md:text-2xl lg:text-3xl font-nunito700 text-black">
        {comparisonTable.title}
      </h2>

      {isMobileOrTablet ? (
        <ComparisonTableMobile comparisonTable={comparisonTable} />
      ) : (
        <ComparisonTableDesktop comparisonTable={comparisonTable} />
      )}
    </div>
  );
};

export { ComparisonTable };
